export enum DeliverableType {
  UNKNOWN,
  WALL_ONLY,
  ROOF_ONLY,
  COMPLETE,
  NOW,
  TOTAL_LIVING_AREA_PLUS,
  TOTAL_LIVING_AREA,
  CAPTURE_ONLY,
  INTERIOR_FLOOR_PLAN,
  BUILD_ALL,
}
